import { createContext } from 'react'

export interface ISeminarAppContext {
  isSeminar: boolean
  isSeminarSearchEnabled: boolean
}

export const SeminarAppContext = createContext<ISeminarAppContext>({
  isSeminar: false,
  isSeminarSearchEnabled: false,
})
